import { render, staticRenderFns } from "./Title_CustomerGroup.vue?vue&type=template&id=315d4c5e&scoped=true&"
import script from "./Title_CustomerGroup.vue?vue&type=script&lang=js&"
export * from "./Title_CustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d4c5e",
  null
  
)

export default component.exports